"use client";

import Link from "next/link";

import { Button, Modal, Stack, Text } from "@/components/ui/elements";

import { CARE_GACHA_ANNOUNCEMENT_PATH } from "./_function";

type Props = {
  opened: boolean;
  /** 「くわしく見る」と閉じる（×）の両方から呼ぶ。表示済みの記録もここで行う */
  onClose: () => void;
};

/**
 * ケアガチャ事前告知のログイン時ダイアログ。
 * 文言は仮置きで、運営の確定後に差し替える。
 */
export function CareGachaAnnouncementDialog({ opened, onClose }: Props) {
  return (
    <Modal
      opened={opened}
      close={onClose}
      centered
      size="md"
      padding="xl"
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeButtonProps={{ "aria-label": "閉じる" }}
      title="ケアガチャ、はじまるかも!?"
    >
      <Stack gap="md">
        <Text size="sm" lh={1.7} c="dark.6">
          勤務おつかれさま、のごほうびに。
          <br />
          勤務を完了するとチケットがもらえる新しいおたのしみを準備しています。
        </Text>

        <Button
          component={Link}
          href={CARE_GACHA_ANNOUNCEMENT_PATH}
          onClick={onClose}
          color="teal"
          size="lg"
          radius="xl"
          fullWidth
          fz={15}
          fw={700}
        >
          くわしく見る
        </Button>
      </Stack>
    </Modal>
  );
}
